import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateModeOfPayment } from "../../../../api/modeOfPaymentApi";
import { modeOfPaymentSchema } from "../../schemas/modeOfPaymentSchema";
const UpdateModeOfPaymentDialog = ({
  openUpdateModeOfPayment,
  handleCloseUpdateModeOfPayment,
  currentModeOfPayment,
  fetchModeOfPayments,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(modeOfPaymentSchema),
    defaultValues: {
      id: "",
      name: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.id = currentModeOfPayment.id;
    defaultValues.serviceId = currentModeOfPayment.serviceId;
    defaultValues.name = currentModeOfPayment.name;
    defaultValues.email = currentModeOfPayment.email;
    defaultValues.price = currentModeOfPayment.price;
    reset({ ...defaultValues });
  }, [currentModeOfPayment, reset]);

  const submitUpdateModeOfPayment = async (values) => {
    await updateModeOfPayment(values);
    handleCloseUpdateModeOfPayment();
    fetchModeOfPayments();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateModeOfPayment}
        onClose={handleCloseUpdateModeOfPayment}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Mode of Payment</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateModeOfPayment)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Mode of Payment"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseUpdateModeOfPayment}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateModeOfPaymentDialog;
